export default "__VITE_ASSET__DllUcAy7__"